import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardHeaderComponent } from './dashboard-header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [DashboardHeaderComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [DashboardHeaderComponent],
})
export class DashboardHeaderModule {}
